import { useColorScheme } from "@mui/material/styles";
export const useThemeMode = () => {
    const { mode, systemMode, setMode } = useColorScheme();
    const applied = mode === "system" ? systemMode : mode;
    const resolved = applied === "dark" ? "dark" : "light";
    return {
        mode: resolved,
        setMode,
        preference: mode !== null && mode !== void 0 ? mode : "system",
        setPreference: setMode,
        toggleAppearance: () => {
            const target = resolved === "dark" ? "light" : "dark";
            const osPreference = systemMode !== null && systemMode !== void 0 ? systemMode : (window.matchMedia("(prefers-color-scheme: dark)").matches
                ? "dark"
                : "light");
            setMode(target === osPreference ? "system" : target);
        },
    };
};
//# sourceMappingURL=themeMode.js.map